/**
 * Names of all the workers
 */ export var Worker = /*#__PURE__*/ function(Worker) {
    Worker["AugloopTileSync"] = "AugloopTileSync";
    Worker["BasicPlanContainerFetcher"] = "BasicPlanContainerFetcher";
    Worker["BasicPlanOpenTracker"] = "BasicPlanOpenTracker";
    Worker["BasicPlanConversionTracker"] = "BasicPlanConversionTracker";
    Worker["BootObserver"] = "BootObserver";
    Worker["CdsProvisioningStatus"] = "CdsProvisioningStatus";
    Worker["ChildAppInstantiationWorker"] = "ChildAppInstantiationWorker";
    Worker["DeltaSync"] = "DeltaSync";
    Worker["DeltaSyncFeedProcessor"] = "DeltaSyncFeedProcessor";
    Worker["HistoryObserver"] = "HistoryObserver";
    Worker["Navigation"] = "Navigation";
    Worker["NetworkConnectivity"] = "NetworkConnectivity";
    Worker["OperationTracking"] = "OperationTracking";
    Worker["PerformanceObserver"] = "PerformanceObserver";
    Worker["PlanConversionStatusTracker"] = "PlanConversionStatusTracker";
    Worker["PremiumPlanCreationStatus"] = "PremiumPlanCreationStatus";
    Worker["ProjectTrialOperationTracker"] = "ProjectTrialOperationTracker";
    Worker["StoreHydration"] = "StoreHydration";
    Worker["DataFetch"] = "DataFetch";
    Worker["CacheUpdate"] = "CacheUpdate";
    Worker["Mru"] = "Mru";
    Worker["TeamsTab"] = "TeamsTab";
    Worker["Modal"] = "Modal";
    Worker["CacheEviction"] = "CacheEviction";
    Worker["Campaign"] = "Campaign";
    Worker["ServiceWorkerBootstrap"] = "ServiceWorkerBootstrap";
    return Worker;
}({});
